import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=24cae943&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24cae943')) {
      api.createRecord('24cae943', component.options)
    } else {
      api.reload('24cae943', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=24cae943&", function () {
      api.rerender('24cae943', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/Header.vue"
export default component.exports